import { IHSBLocationManager } from "core/interfaces/data/IHSBLocationManager";
import { setStep } from "core/redux/features/session/sessionSlice";
import { ISessionStateData } from "core/redux/features/session/sessionSliceInterfaces";
import { useAppDispatch } from "core/redux/store/hooks";

import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import { PagesEnum } from "types/PagesEnum";
import { formStep, personalAreaStep } from "types/StepEnums";
import { move } from "../types/move";
import { performAsyncFunction } from "./AsyncFunctionUtility";
import { getCurrentPageName, pagesDictionaryFromEnum, pagesEnumFromPageName } from "./NavigationHelper";
import { useErrorHandler } from "react-error-boundary";
import useSession from "./Session";
import { StorageHelper } from "./SessionStorageHelper";
// import { selectParametri } from "core/redux/features/parametri/parametriSlice";
// import { HSBTipoRicercaRisorsaUmanaEnum } from "types/HSBTipoRicercaRisorsaUmanaEnum";

const NavigationManager = (sessionInfo: ISessionStateData) => {
	let navigate = useNavigate();
	let location = useLocation() as IHSBLocationManager;
	let dispatch = useAppDispatch();
	const handleError = useErrorHandler();
	const { initSession } = useSession(sessionInfo);


	const getNextStep = useCallback(
		(currentStep: formStep): formStep => {
			switch (currentStep) {
				// case formStep.Prestazione:
				// 	if (parametriInfo.HSBTipoRicercaRisorsaUmana !== HSBTipoRicercaRisorsaUmanaEnum.Generiche) {
				// 		return formStep.Professionista;
				// 	} else {
				// 		return formStep.DataPreventivo;
				// 	}
				default:
					return currentStep + 1;
			}
		},
		[
			/*parametriInfo.HSBTipoRicercaRisorsaUmana*/
		]
	);

	let CheckBackNavAllowed = useCallback((page: PagesEnum, step: formStep | personalAreaStep, changePasswordRequired: boolean) => {
		let res: boolean = true;

		switch (page) {
			case PagesEnum.ReservationForm:
				//	if (typeof (step) == typeof (formStep)) {
				switch (step) {
					case formStep.ResultPrenotazione:
					case formStep.Authentication:
					case formStep.SelectAssistito:
					case formStep.SelectModalitaPagamento:
						res = false;
						break;
					default:
						res = true;
						break;
				}
				//		}
				break;
			case PagesEnum.Payment:
				// if (typeof (step) == typeof (formStep)) {
				res = false;
				// }
				break;

			case PagesEnum.ChangePassword:
				if (changePasswordRequired || StorageHelper.hasItem("resetPasswordToken")) {
					res = false;
				}
				break;
		}

		return res;
	}, []);

	const MAX_STEP = 10;

	// const getCurrentStep = useCallback((): number => {
	// 	if (typeof sessionInfo.step == typeof formStep) return sessionInfo.step as formStep;
	// 	return Number.parseInt(sessionInfo.step.toString() as personalAreaStep);
	// }, [sessionInfo.step]);

	// const currentStep = getCurrentStep();

	const GoBack = (replace: boolean = false) => {
		if (replace && location.state && location.state.from) {
			var prevLocation = location.state.from;
			navigate({ pathname: `${prevLocation.pathname}`, search: prevLocation.search }, { state: prevLocation.state, replace: replace });
		} else {
			navigate(-1);
		}
	};

	// eslint-disable-next-line
	const GoOn = () => {
		navigate(1);
	};

	const GoToStep = useCallback(
		(newStep: formStep, otherStateProps: any = undefined, replace?: boolean) => {
			// console.log("GO TO STEP",newStep,sessionInfo.step)
			if (newStep !== sessionInfo.step) {
				// console.log("%ceffectively go"+newStep+"  "+sessionInfo.step,"color:orange")
				var backAllowed = CheckBackNavAllowed(
					pagesEnumFromPageName[getCurrentPageName(location.pathname)],
					newStep,
					sessionInfo.changePasswordRequired
				);

				let replaceHistory = replace ?? false;
				dispatch(setStep(newStep));
				navigate(
					{ pathname: `${location.pathname}`, search: location.search },
					{ state: { newStep: newStep, from: location, backNavAllowed: backAllowed, ...otherStateProps }, replace: replaceHistory }
				);

				document.documentElement.scrollIntoView({
					behavior: "smooth",
					block: "start",
					inline: "start",
				});
			}
		},
		[CheckBackNavAllowed, dispatch, location, navigate, sessionInfo.changePasswordRequired, sessionInfo.step]
	);

	const GoToPage = useCallback(
		(page: PagesEnum, step: formStep | personalAreaStep | undefined = undefined, otherStateProps: any = undefined, replace: boolean = false) => {
			var currentpage = pagesEnumFromPageName[getCurrentPageName(location.pathname)];

			let pageNewStep = step ?? sessionInfo.step;

			if (currentpage !== PagesEnum.ChangePassword || !sessionInfo.changePasswordRequired) {
				var backAllowed = CheckBackNavAllowed(page, pageNewStep, sessionInfo.changePasswordRequired);
				if (pageNewStep !== sessionInfo.step) {
					dispatch(setStep(pageNewStep));
				}
				navigate(
					{ pathname: `/${pagesDictionaryFromEnum[page]}`, search: location.search },
					{ replace: replace, state: { newStep: pageNewStep, from: location, backNavAllowed: backAllowed, ...otherStateProps } }
				);

				document.documentElement.scrollIntoView({
					behavior: "smooth",
					block: "start",
					inline: "start",
				});
			}
		},
		[CheckBackNavAllowed, dispatch, location, navigate, sessionInfo.changePasswordRequired, sessionInfo.step]
	);

	const NextStep = useCallback(
		(replace?: boolean) => {
			// console.log("NEXT, replace:",replace)
			if (getNextStep(sessionInfo.step as number) > MAX_STEP) {
				return;
			}
			GoToStep(getNextStep(sessionInfo.step as number), undefined, replace);
		},
		[GoToStep, getNextStep, sessionInfo.step]
	);

	const PrevStep = useCallback(
		(dataForm?: any) => {
			if ((sessionInfo.step as number) - 1 < 0) {
				return;
			}
			GoToStep((sessionInfo.step as number) - 1, { dataForm });
		},
		[GoToStep, sessionInfo.step]
	);

	const MoveStep = useCallback(
		(move: move, replace?: boolean) => {
			// console.log("MOVE",move)
			if (move === "next") {
				NextStep(replace);
			}

			if (move === "prev") {
				PrevStep();
			}
		},
		[NextStep, PrevStep]
	);

	const GoToHomepage = useCallback(
		(setLoadingPage: (state: boolean) => void) => {
			if (StorageHelper.hasItem("resetPasswordToken")) {
				GoToPage(PagesEnum.ChangePassword, undefined, undefined, true);
			} else if (StorageHelper.hasItem("activity-owner") || StorageHelper.hasItem("default-activity")) {
				performAsyncFunction(async () => {
					if (!sessionInfo.sessione) {
						await initSession();
					}
					GoToStep(formStep.Area);
					setLoadingPage(false);
				}, handleError);
			} else {
				GoToPage(PagesEnum.ReservationForm, formStep.Home);
				setLoadingPage(false);
			}
		},
		[GoToPage, GoToStep, handleError, initSession, sessionInfo.sessione]
	);

	return {
		// currentStep,
		// getCurrentStep,
		NextStep,
		PrevStep,
		MoveStep,
		GoBack,
		GoOn,
		GoToStep,
		CheckBackNavAllowed,
		GoToPage,
		GoToHomepage,
		getNextStep,
	};
};

export default NavigationManager;
